declare global {
    interface Window { dataLayer: any; }
}

export default function gtag(...args: any): void {
  window.dataLayer.push(arguments);
}
